// This file was called templateSidebar.php in the old gregsandell.com
import React, {useContext, useState} from 'react'
import { Slide } from 'react-slideshow-image'
import 'react-slideshow-image/dist/styles.css'
import {
  iLinkObj,
  iBlogObj2,
  iClient
} from '../../managers/interfaces'
import { Link } from 'react-router-dom'
import wikiGoldImg from '../../image/wikipediaExternalPageGold.png'
import wikiBackImg from '../../image/wikipediaBackArrow.png'
import funride from '../../lib/funride/funride.module.less'
import ManagersContext from '../../containers/ManagersContext'
import { GLOBALS, LINKTYPES } from '../../types'
import { scramble, createAscendingArray } from '../../utils'

interface iTemplateSidebarProps {
  g_sidebarKey: string,
  g_slideshowKey: string
  g_section: string
  linksTitle: string
}
export default function TemplateSidebar (props:iTemplateSidebarProps) {
  const {sidebarPageManager, objPortfolio} = useContext(ManagersContext)
  const sidebar = sidebarPageManager.getSidebar(props.g_sidebarKey)

  return (
    <>
      <SidebarLinks linksTitle={props.linksTitle} linksArray={sidebar.linksArray} />
      <SidebarBlogs blogsArray={sidebar.blogsArray} />
      <PortfolioLinks clients={objPortfolio.clients} g_section={props.g_section} />
      <Slideshow g_slideshowKey={props.g_slideshowKey} />
    </>
  )
}
interface iSidebarLinksProps {
  linksTitle: string,
  linksArray: {[index: string]:iLinkObj}
}

// linksTitle is either 'Other Links' (one place) or 'Other Site Links' (5 places)
const SidebarLinks = (props:iSidebarLinksProps) => {
  const currentPagePath = window.location.pathname
  return Object.keys(props.linksArray).length > 0
    ? (
      <div className={funride.sidebarSpacer}>
        <ul>
          <li>
            <h2>{props.linksTitle}</h2>
            <ul> {
              Object.keys(props.linksArray).length > 0
                ? (
                  <ul> {
                    Object.keys(props.linksArray).map((key, i) => {
                      const linkObj = props.linksArray[key]
                      // TO DO Can LinkObj actually have empty string for its type?
                      // TO DO there are no instances of LINKTYPES.internalStatic
                      return (
                        <li key={`link_${i}`}>
                          {(linkObj.type === LINKTYPES.internal || linkObj.type === '') && (
                            <Link to={linkObj.path}>{linkObj.text}</Link>
                          )}
                          {(linkObj.type === LINKTYPES.internalStatic || linkObj.type === '') && (
                            <a href={linkObj.path}>{linkObj.text}</a>
                          )}
                          {(linkObj.type === LINKTYPES.internalStaticDownload || linkObj.type === '') && (
                            <a href={linkObj.path} rel='noreferrer' target='_blank' download>{linkObj.text}</a>
                          )}
                          {linkObj.type === LINKTYPES.backlink && linkObj.path !== currentPagePath && (
                            <div>
                              <img src={wikiBackImg} alt='Back'/>
                              {' '}<a href={linkObj.path}>
                                {linkObj.text}
                              </a>
                            </div>
                          )}
                        </li>
                      )
                    })
                  } </ul>)
                : null
            }
            </ul>
          </li>
        </ul>
      </div>)
    : null
}
interface iSlideshowProps {
  g_slideshowKey: string
}

const Slideshow = (props:iSlideshowProps) => {
  const { slideshowManager } = useContext(ManagersContext)
  const slideshow = slideshowManager.get(props.g_slideshowKey || 'nothing')

  const slideshowProps = {
    prevArrow: <></>,
    nextArrow: <></>,
    duration: GLOBALS.slideshowSpeed,
    transitionDuration: slideshow ? slideshow.slideDur : 0
  }
  const numSlides = props.g_slideshowKey ? slideshow.imgsArray.length : 0
  const slidesOrder = scramble(createAscendingArray(0, numSlides - 1))

  // eslint-disable-next-line multiline-ternary
  // eslint-disable
  return (props.g_slideshowKey) ? (
    <div className={funride.sidebarSpacer}>
      <h2>{slideshow.title}</h2>
      <Slide { ...slideshowProps } >
        { slidesOrder.map((idx: number) => {
          const img = slideshow.imgsArray[idx]
          return (
            <div className="each-slide-effect" style={{marginLeft: '15px', marginTop: '7px', height: img.data.height, width: img.data.width}} key={`slide${idx}`}>
              <a href={`/tech/category/${img.data.categoryKey}`}>
                {/*Looks for this image path relative to /public*/}
                <img width='100%' src={`/image/${slideshow.imgsSubdir}/${img.file}`} />
              </a>
            </div>
          )
        }
        )}
      </Slide>
    </div>
  ) : null
}
interface iSidebarBlogs {
  blogsArray: {[index: string]:iBlogObj2}
}
const SidebarBlogs = (props:iSidebarBlogs) => {
  return Object.keys(props.blogsArray).length > 0
    ? (
      <div className={funride.sidebarSpacer}>
        <h2>Most Recent Blogs</h2>
        <ul> {
          Object.keys(props.blogsArray).map((key, i) => {
            const blogObj = props.blogsArray[key]
            return (
              <li key={`blog_${i}`}>
                <h3>{blogObj.date}</h3>
                <p>
                  <a href={blogObj.url} rel='ext noreferrer' target='_blank'>{blogObj.text}
                  </a>{' '}<img src={wikiGoldImg} alt='External Page' />
                </p>
              </li>
            )
          })
        } </ul>
      </div>)
    : null
}

interface iPortfolioLinksProps {
  g_section: string
  clients: Record<string, iClient>
}
const portfolioSubset = (clients: Record<string, iClient>, start: number, end: number) => {
  const clientKeys = Object.keys(clients)

  return createAscendingArray(start, end).map((idx: number) => {
    const clientKey = clientKeys[idx]
    const client = clients[clientKey]
    return (
      <li key={`client_${idx}`}>
        <a
          href={`/portfolio/${clientKey}/splash`}
          // onMouseOver={() => dispatch(setClientState({ key, type: 'splash' }))}
        >{client.linkText}</a>
      </li>
    )
  })
}

const PortfolioLinks = (props:iPortfolioLinksProps) => {
  const [showMore, setShowMore] = useState<boolean>(false)

  const toggleMore = () => setShowMore(!showMore)
  const clientKeys = Object.keys(props.clients)
  // const dispatch = useDispatch()

  // eslint-disable-next-line multiline-ternary
  return props.g_section === 'portfolio' ? (
    <div className={funride.sidebarSpacer}>
      <ul>
        <li id='submenu'>
          <h2>Companies</h2>
          <ul> {
            portfolioSubset(props.clients, 0, 6)
          }
          </ul>
          <div
            style={{display: showMore ? 'none' : 'block'}}
            className={funride.hideShowLink}
            onClick={toggleMore}>Show more companies...</div>
          <div style={{display: showMore ? 'block' : 'none'}}>
            <ul> {
              portfolioSubset(props.clients, 7, clientKeys.length - 1)
            }
            </ul>
            <div
              style={{display: showMore ? 'block' : 'none'}}
              className={funride.hideShowLink}
              onClick={toggleMore}>...Fewer companies</div>
          </div>
        </li>
      </ul>
    </div>
  )
    : null
}
